// extracted by mini-css-extract-plugin
module.exports = {"days":"_eZ","additionalInfo":"_e0","hidden":"_e1","centerMenu":"_e2","logo":"_e3","social":"_e4","socialLink":"_e5"};